import { memo, useState } from 'react';
import { Box, Button, ClickAwayListener, useMediaQuery, useTheme } from '@mui/material';
import { useToggle } from '@dfl/hook-utils';
import { CommissionLogisticIcon } from 'modules/inventory/common/components/Icons/CommissionLogisticIcon';
import { ArrowOutward } from '@mui/icons-material';
import { LongText } from '@dfl/mui-react-common';
import { IStockWarehouses } from '../../interfaces/IProduct';
import { CustomTooltip } from '../ProductPrice/LogisticWarehouseView/styled';
import WarehouseStockList from './WarehouseStockList';

type Props = {
  warehouses: IStockWarehouses[];
  title?: string;
  size?: 'small' | 'medium';
  fullWidth?: boolean;
  setValue?: any;
};

const ProductStockView = ({
  warehouses,
  size = 'small',
  title,
  fullWidth = false,
}: Props) => {
  const { isOpen, onOpen, onClose } = useToggle(false);
  const theme = useTheme();
  const isResp = useMediaQuery(theme.breakpoints.down('sm'));
  const [disableFocus, setDisableFocus] = useState(true);

  const handleClickAway = () => {
    setDisableFocus(false);
  };
  const handleOpen = () => {
    onOpen();
    setDisableFocus(true);
  };

  if (!warehouses) return <></>;

  return (
    <ClickAwayListener onClickAway={handleClickAway} mouseEvent='onMouseDown' touchEvent='onTouchStart'>
      <Box sx={{ width: fullWidth ? '100%' : 'auto' }}>
        <CustomTooltip
          PopperProps={{
            disablePortal: true,
          }}
          placement={isResp ? 'bottom' : 'bottom-start'}
          arrow
          onClose={onClose}
          open={isOpen}
          disableHoverListener
          disableTouchListener
          disableFocusListener={disableFocus}
          title={<WarehouseStockList warehouses={warehouses} />}
        >
          <Button
            startIcon={<CommissionLogisticIcon fontSize='inherit' />}
            endIcon={
              <ArrowOutward
                fontSize='small'
                sx={{
                  transform: 'rotate(90deg)',
                  fontSize: 16,
                  position: 'absolute',
                  bottom: 4,
                  right: 4,
                }}
              />
            }
            variant='text'
            size={size}
            onClick={handleOpen}
            fullWidth={fullWidth}
            sx={{ minWidth: 45, height: '100%', position: 'relative', textAlign: 'left' }}
          >
            <LongText lineClamp={1} text={title} />
          </Button>
        </CustomTooltip>
      </Box>
    </ClickAwayListener >
  );
};

export default memo(ProductStockView);
